const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let initialized = false;

export const initGA = () => {
  if (initialized || !GA_ID || GA_ID === "G-XXXXXXXXXX") return;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, {
    send_page_view: false,
  });

  initialized = true;
};

const gtag = (...args) => {
  if (window.gtag) window.gtag(...args);
};

export const trackPageView = (path, title) => {
  gtag("event", "page_view", {
    page_path: path,
    page_title: title || document.title,
    page_location: window.location.href,
  });
};

export const trackEvent = (eventName, params = {}) => {
  gtag("event", eventName, params);
};

export const trackClick = (label, category = "engagement", extra = {}) => {
  gtag("event", "click", {
    event_category: category,
    event_label: label,
    ...extra,
  });
};

export const trackScroll = (depth, page) => {
  gtag("event", "scroll_depth", {
    event_category: "engagement",
    event_label: page,
    value: depth,
    scroll_percentage: depth,
  });
};

export const trackTimeOnPage = (seconds, page) => {
  gtag("event", "time_on_page", {
    event_category: "engagement",
    event_label: page,
    value: Math.round(seconds),
    time_seconds: Math.round(seconds),
  });
};

export const trackActiveTime = (seconds, page) => {
  gtag("event", "active_time", {
    event_category: "engagement",
    event_label: page,
    value: Math.round(seconds),
    active_seconds: Math.round(seconds),
  });
};

export const trackReadingProgress = (articleId, articleTitle, percentage) => {
  gtag("event", "reading_progress", {
    event_category: "content",
    event_label: articleTitle,
    article_id: articleId,
    read_percentage: percentage,
  });
};

export const trackSectionView = (articleId, sectionName) => {
  gtag("event", "section_view", {
    event_category: "content",
    event_label: sectionName,
    article_id: articleId,
  });
};

export const trackArticleOpen = (articleId, articleTitle, category) => {
  gtag("event", "article_open", {
    event_category: "content",
    event_label: articleTitle,
    article_id: articleId,
    article_category: category,
  });
};

export const trackArticleComplete = (articleId, articleTitle, timeSpent) => {
  gtag("event", "article_complete", {
    event_category: "content",
    event_label: articleTitle,
    article_id: articleId,
    time_spent_seconds: Math.round(timeSpent),
  });
};

export const trackSearch = (query, resultsCount) => {
  gtag("event", "search", {
    search_term: query,
    results_count: resultsCount,
  });
};

export const trackShare = (method, contentType, itemId) => {
  gtag("event", "share", {
    method,
    content_type: contentType,
    item_id: itemId,
  });
};

export const trackSignUp = (method) => {
  gtag("event", "sign_up", { method });
};

export const trackLogin = (method) => {
  gtag("event", "login", { method });
};

export const trackCategorySwitch = (fromCategory, toCategory) => {
  gtag("event", "category_switch", {
    event_category: "navigation",
    from_category: fromCategory,
    to_category: toCategory,
  });
};

export const trackReaction = (articleId, reactionType) => {
  gtag("event", "reaction", {
    event_category: "engagement",
    event_label: reactionType,
    article_id: articleId,
  });
};

export const trackOpinionSubmit = (articleId) => {
  gtag("event", "opinion_submit", {
    event_category: "engagement",
    article_id: articleId,
  });
};

export const trackBookmark = (articleId, action) => {
  gtag("event", "bookmark", {
    event_category: "engagement",
    event_label: action,
    article_id: articleId,
  });
};

export const trackExternalLink = (url, context) => {
  gtag("event", "external_link", {
    event_category: "outbound",
    event_label: url,
    link_context: context,
  });
};

export const trackError = (errorMessage, context) => {
  gtag("event", "exception", {
    description: errorMessage,
    fatal: false,
    error_context: context,
  });
};

export const setUserProperties = (userId, properties = {}) => {
  if (window.gtag) {
    window.gtag("set", "user_properties", {
      user_id: userId,
      ...properties,
    });
    window.gtag("config", GA_ID, { user_id: userId });
  }
};
